import xhr from 'xhr.js';
import auth from 'services/auth';

const service_accounts = {
    getAccountBySlug: async (slug) => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/account-slug/${slug}`, {
            withCredentials: true
        });
        return res.data;
    },
    getSenderProfiles: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/accounts/${account_id}/sender-profiles`, {
            withCredentials: true
        });
        return res.data;
    },
    createSenderProfile: async (email, name) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/accounts/${account_id}/sender-profiles`,
            { email, name },
            { withCredentials: true }
        );

        return res.data;
    },
    updateSenderProfile: async (id, email, name) => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/accounts/${account_id}/sender-profiles/${id}`,
            { email, name },
            { withCredentials: true }
        );

        return res.data;
    },
    deleteSenderProfile: async (id, email, name) => {
        const account_id = auth.getAccountId();
        const res = await xhr.delete(
            `/accounts/${account_id}/sender-profiles/${id}`,
            { withCredentials: true }
        );

        return res.data;
    },
    createDomain: async (domain) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/accounts/${account_id}/domains`,
            { domain },
            { withCredentials: true }
        );

        return res.data;
    },
    verifyDomain: async (id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/accounts/${account_id}/domains/${id}/verify`,
            { },
            { withCredentials: true }
        );

        return res.data;
    },
    deleteDomain: async (id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.delete(
            `/accounts/${account_id}/domains/${id}`,
            { withCredentials: true }
        );

        return res.data;
    },

    getEmailTemplatesAndLatestEmails: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/email-templates-and-latest-emails`, {
            withCredentials: true,
            params: {
                account_id
            }
        });
        return res.data;
    },
    getEmailTemplates: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/email-templates`, {
            withCredentials: true,
            params: {
                account_id
            }
        });
        return res.data;
    },
    getEmailTemplate: async (id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/email-templates/${id}`, {
            withCredentials: true,
            params: {
                account_id
            }
        });
        return res.data;
    },
    createEmailTemplate: async (emailTemplate) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(
            `/email-templates`,
            { account_id, ...emailTemplate },
            { withCredentials: true }
        );

        return res.data;
    },
    updateEmailTemplate: async (emailTemplate) => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/email-templates/${emailTemplate.id}`,
            { ...emailTemplate, account_id },
            { withCredentials: true }
        );

        return res.data;
    },
    deleteEmailTemplate: async (email_template_id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.delete(
            `/email-templates/${email_template_id}`, {
                withCredentials: true,
                params: {
                    account_id
                }
            }
        );

        return res.data;
    },
    getUsage: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/accounts/${account_id}/email-usage`, {
            withCredentials: true
        });
        return res.data;
    },
};

export default service_accounts;
